import { render, staticRenderFns } from "./LuckDraw.vue?vue&type=template&id=13b879c0"
import script from "./LuckDraw.vue?vue&type=script&lang=js"
export * from "./LuckDraw.vue?vue&type=script&lang=js"
import style0 from "./LuckDraw.vue?vue&type=style&index=0&id=13b879c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports